import { render, staticRenderFns } from "./DriverCollectionDetails.vue?vue&type=template&id=31d0dcf6&scoped=true&"
import script from "./DriverCollectionDetails.vue?vue&type=script&lang=js&"
export * from "./DriverCollectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./DriverCollectionDetails.vue?vue&type=style&index=0&id=31d0dcf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d0dcf6",
  null
  
)

export default component.exports